module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Heavy.72b244a4.woff2";